module.exports = __webpack_public_path__ + "img/kingz-logo.e300d16d.png";